module.exports = __webpack_public_path__ + "img/RFLSH.8f6041b7.svg";